import { useMutation } from "react-query";
import api from "../../utils/api";

export default function usePost(url) {
  return useMutation((payload) => api.post(url, payload));
}
